export enum TipoEscopoEnum {
    UfDestino = 1,
    UfOrigem = 2,
    Ncm = 3,
    Cest = 4,
    OrigemMercadoria = 5,
    Produto = 6,
    IndicadorInscricaoEstadual = 7,
    RegimeTrib = 10,
    TipoTributario = 11,
    TipoItem = 12,
    CodigoTribNacional = 13,
    Nbs = 14,
    Servico = 15,
    ContribIbsCbs = 16
}
